export default "__VITE_ASSET__BW1by5ps__"